var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 11,
    width: 1.76,
    height: 18,
    rx: 0.88,
    transform: "rotate(90 21 11)",
    fill: "#2A2D31"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.88,
    y: 21,
    width: 1.76,
    height: 18,
    rx: 0.88,
    transform: "rotate(-180 12.88 21)",
    fill: "#2A2D31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.8dc2265fa9e36ced676888728117d73b.svg";
export { ForwardRef as ReactComponent };